module.exports = __webpack_public_path__ + "static/media/stock-taking.47136264.jpg";